import React from 'react';

import { func_validation, func_cookieSetting, func_datetime, isNumberValid, isStringTrimNotEmpty, isDateValid } from 'functions';
import moment from 'moment';
import Toggle from 'components/buttons/Toggle';
import { useDispatch } from 'react-redux';
import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';

export function useColumns() {
    const { updateTrialStatus } = useAccountControlActions();

    function getColumns_companyId() {
        let columnClassName = "table__column-company-id";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Com ID",
            id: "comId",
            accessor: "ComId",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }
    
    function getColumns_companyName() {
        let columnClassName = "table__column-company-name";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Company Name",
            id: "companyName",
            accessor: "ComName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumns_package() {
        let columnClassName = "table__column-package";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Package",
            id: "package",
            accessor: "PackageName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumns_billingTag() {
        let columnClassName = "table__column-billing-tag";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Billing Tag",
            id: "billingTag",
            accessor: "BillingTag",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumns_dealerCode() {
        let columnClassName = "table__column-dealer-code";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Dealer Code",
            id: "dealerCode",
            accessor: "DealerCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumns_isTrial() {
        let columnClassName = "table__column-is-trial d-flex justify-content-center";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Trial",
            id: "isTrial",
            accessor: "Trial",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;

                return (
                    <div className={"noWrap-text-ellipsis"}>
                        <Toggle isActiveInit={value} onToggle={() => updateTrialStatus(props?.row?.original?.ComId, value)} />
                    </div>
                );
            },
        }
    }

    function getColumns_trialExpiryDate() {
        let columnClassName = "table__trial-expiry-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Trial Expiry Date",
            id: "trialExpiryDate",
            accessor: "TrialExpiryDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isDateValid(value))
                    value_formatted = moment(value).format("DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumns_isSuspended() {
        let columnClassName = "table__column-is-suspended d-flex justify-content-center";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Suspended",
            id: "isSuspended",
            accessor: "Suspended",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        {value? value:"-"}
                    </div>
                );
            },
        }
    }

    function getColumns_suspendDate() {
        let columnClassName = "table__suspend-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Suspend Date",
            id: "suspendDate",
            accessor: "SuspendDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isDateValid(value))
                    value_formatted = moment(value).format("DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }
    
    function getColumns_paymentDate() {
        let columnClassName = "table__payment-due";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Payment Due",
            id: "paymentDue",
            accessor: "PaymentDueDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = "-";
                if (isDateValid(value))
                    value_formatted = moment(value).format("DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }
    

    return [
        getColumns_companyId(),
        getColumns_companyName(),
        getColumns_dealerCode(),
        getColumns_billingTag(),
        getColumns_package(),
        getColumns_isTrial(),
        getColumns_trialExpiryDate(),
        getColumns_isSuspended(),
        getColumns_suspendDate(),
        getColumns_paymentDate(),

    ];
}